import { GetStaticProps } from 'next';
import { StoryData } from 'storyblok-js-client';

import Layout from '../components/Layout';
import Ambassadors from '../components/PageTypes/Ambassadors';
import { imageOgStaticLoader } from '../helpers/og-image';
import { AnalyticsFlowProvider } from '../utils/analytics/flow';
import { getStoryblokPage, useStoryblok } from '../utils/storyblok';
import { pageTranslations } from '../utils/translations';

const Page = ({ locale, locales, ogImageUrl, preview, story }: PageProps) => {
  const { content } = useStoryblok<StoryData<AffiliatesPageType>>(
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    story,
    preview,
    locale,
  );

  return (
    <Layout
      description={content.seo.description}
      locale={locale}
      locales={locales}
      ogImageUrl={ogImageUrl}
      title={content.seo.title}
    >
      <AnalyticsFlowProvider name="ambassadors" sendViewedEvent>
        {() => <Ambassadors content={content} />}
      </AnalyticsFlowProvider>
    </Layout>
  );
};

export default Page;

export const getStaticProps: GetStaticProps = async ({
  locale,
  locales,
  preview = false,
}) => {
  const page = await getStoryblokPage('cdn/stories/ambassadors', {
    locale,
    preview,
    resolve_relations: ['affiliates.artists'],
  });

  if (page === null) {
    return {
      notFound: true,
    };
  }

  const ogImageUrl = await imageOgStaticLoader({
    titleKey: { key: 'og:ambassadors.title' },
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    imageSrc: page.data.conten?.introImages[1]?.filename
      ? page.data.content?.introImages[1].filename // eslint-disable-line @typescript-eslint/no-unsafe-member-access
      : 'https://a.storyblok.com/f/119968/4000x2667/846735f337/parra-atelier-2.jpg',
    imageWidth: 1200,
    imageHeight: 630,
    overlay: true,
    locale,
  });

  return {
    props: {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
      story: page.data ? page.data.story : false,
      preview,
      locale,
      locales,
      ogImageUrl,
      ...(await pageTranslations(locale!, ['og'])),
    },
  };
};
